import { render, staticRenderFns } from "./PropiedadC.vue?vue&type=template&id=4f9800ec&scoped=true&"
import script from "./PropiedadC.vue?vue&type=script&lang=js&"
export * from "./PropiedadC.vue?vue&type=script&lang=js&"
import style0 from "./PropiedadC.vue?vue&type=style&index=0&id=4f9800ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9800ec",
  null
  
)

export default component.exports